export const currentClassroom = ({ currentClassroom }) => currentClassroom
export const editUserDialog = ({ editUserDialog }) => editUserDialog
